<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import api from "@/axios";
import Loader from "../components/loader";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Postagem",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Loader
  },
  data() {
    return {
      updating: true,
      title: "Postagem",
      items: [
        {
          text: "Suporte",
          href: "/",
        },
        {
          text: "Postagem",
          active: true,
        },
      ],
    };
  },
  mounted() {
    console.log('mounted suporte-pesquisa_0')
    // eslint-disable-next-line no-unused-vars
    api.get(`${getBaseUrl()}api/testarapi`).then((res) => {
      console.log('then axios')
      console.log(res)
      this.updating = false
    });
  }

};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>

    <div class="row" v-if="!updating">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="pt-3">
              <div class="row justify-content-center">
                <div class="col-xl-8">
                  <div>
                    <div class="text-center">
                      <div class="mb-4">
                        <a href="#" class="badge bg-light font-size-12">
                          <i
                              class="bx bx-purchase-tag-alt align-middle text-muted me-1"
                          ></i>
                          Suporte
                        </a>
                      </div>
                      <h4>Vídeo Capacitação Plataforma</h4>
                      <p class="text-muted mb-4">
                        <i class="mdi mdi-calendar me-1"></i> 24 Mar, 2023
                      </p>
                    </div>

                    <hr />
                    <div class="text-center">
                      <div class="row">
                        <div class="col-sm-4">
                          <div>
                            <p class="text-muted mb-2">Categorias</p>
                            <h5 class="font-size-15">Suporte</h5>
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="mt-4 mt-sm-0">
                            <p class="text-muted mb-2">Data</p>
                            <h5 class="font-size-15">24 Mar, 2023</h5>
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="mt-4 mt-sm-0">
                            <p class="text-muted mb-2">Usuário</p>
                            <h5 class="font-size-15">Usuário Testes 0099</h5>
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr />

                    <div class="my-5">
                      <img
                          src="@/assets/images/small/img-6.jpg"
                          alt=""
                          class="img-thumbnail mx-auto d-block"
                      />
                    </div>

                    <hr />

                    <div class="mt-4">
                      <div class="text-muted font-size-14">
                        <p>
                          Acesse o link http://www.mobagile.com.br com seu usuário e senha e acompanhe o passo a passo de capacitação da nova plataforma.
                        </p>

                        <p class="mb-4">
                          Não esqueça de confirmar seus novos cadastros para que tenham o fluxo correto dentro do ERP.
                        </p>

                        <blockquote
                            class="p-4 border-light border rounded mb-4"
                        >
                          <div class="d-flex">
                            <div class="me-3">
                              <i
                                  class="bx bxs-quote-alt-left text-dark font-size-24"
                              ></i>
                            </div>
                            <div>
                              <p class="mb-0">
                                Informações importantes poderão ser visualizadas na sua área de notificações
                              </p>
                            </div>
                          </div>
                        </blockquote>


                        <div class="mt-4">
                          <h5 class="mb-3">Novidades:</h5>

                          <div>
                            <div class="row">
                              <div class="col-lg-4 col-sm-6">
                                <div>
                                  <ul class="pl-4">
                                    <li class="py-1">Cadastro automático de clientes</li>
                                    <li class="py-1">Notificação de faturamento</li>
                                    <li class="py-1">Rastreamento de carga</li>
                                  </ul>
                                </div>
                              </div>
                              <div class="col-lg-4 col-sm-6">
                                <div>
                                  <ul class="pl-4">
                                    <li class="py-1">Integração com ERP</li>
                                    <li class="py-1">Integração com redes sociais</li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <hr />

                      <div class="mt-5">
                        <h5 class="font-size-15">
                          <i
                              class="bx bx-message-dots text-muted align-middle me-1"
                          ></i>
                          Comentários:
                        </h5>

                        <div>
                          <div class="d-flex py-3">
                            <div class="avatar-xs me-3">
                              <div
                                  class="avatar-title rounded-circle bg-light text-primary"
                              >
                                <i class="bx bxs-user"></i>
                              </div>
                            </div>
                            <div class="flex-grow-1">
                              <h5 class="font-size-14 mb-1">
                                Usuário testes 0099
                                <small class="text-muted float-end"
                                >1 hora</small
                                >
                              </h5>
                              <p class="text-muted">
                                Comentário testes 00000099999
                              </p>
                              <div>
                                <a
                                    href="javascript: void(0);"
                                    class="text-success"
                                ><i class="mdi mdi-reply"></i> Responder</a
                                >
                              </div>
                            </div>
                          </div>


                        </div>
                      </div>

                      <div class="mt-4">
                        <h5 class="font-size-16 mb-3">Deixe sua mensagem</h5>

                        <form>
                          <div class="row">
                            <div class="col-md-6">
                              <div class="mb-3">
                                <label for="commentname-input">Nome</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    id="commentname-input"
                                    placeholder="Entre com nome"
                                />
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="mb-3">
                                <label for="commentemail-input">Email</label>
                                <input
                                    type="email"
                                    class="form-control"
                                    id="commentemail-input"
                                    placeholder="Entre com e-mail"
                                />
                              </div>
                            </div>
                          </div>

                          <div class="mb-3">
                            <label for="commentmessage-input">Mensagem</label>
                            <textarea
                                class="form-control"
                                id="commentmessage-input"
                                placeholder="Sua mensagem..."
                                rows="3"
                            ></textarea>
                          </div>

                          <div class="text-end">
                            <button type="submit" class="btn btn-success w-sm">
                              Confirmar
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end card body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>